export const MessageType = {
  INTERNAL: 'INTERNAL',
  EMAIL: 'EMAIL',
  values: () => {
    return ['INTERNAL', 'EMAIL'];
  },
};
